import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "recompose";
import { Grid, Header } from "semantic-ui-react";
import { withAuthorization } from "../../components/Session/withAuthorization";
import { OrganizationForm } from "../../components/Organizations/OrganizationForm";

const NewOrganizationComponent = ({
  authUser,
  orgId,
  history,
}: {
  [key: string]: any;
}) => (
  <Grid textAlign="center" className="signin-page">
    <Grid.Column style={{ maxWidth: 800 }} textAlign="left">
      <Header content="Create an Organization" textAlign="left" as="h1" />
      <OrganizationForm authUser={authUser} orgId={orgId} history={history} />
    </Grid.Column>
  </Grid>
);

const mapStateToProps = (state: any) => ({
  authUser: state.sessionState.authUser,
  orgId: state.sessionState.orgId,
});

const authCondition = (authUser: any) => !!authUser;

const NewOrganization = compose(
  withAuthorization(authCondition),
  connect(mapStateToProps)
)(withRouter(NewOrganizationComponent));

export default NewOrganization;



// WEBPACK FOOTER //
// ./src/containers/Organizations/new.tsx